module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#proofread",
      toString: function () {
        return this.url;
      }
    }